export const NoRowsStatusType = {
  EMPTY: 'EMPTY',
  SEARCH_EMPTY: 'SEARCH_EMPTY',
  INIT: 'INIT',
  RECEIVE_REGISTER: 'RECEIVE_REGISTER',
  STOCK_RELEASE_REGISTER: 'STOCK_RELEASE_REGISTER',
  NO_DATA: 'NO_DATA',
  /** 배송대행 관리 - 추가 운송장 생성 */
  DELIVERY_AGENCY_ADDITIONAL_SHIPPING_LABEL: 'DELIVERY_AGENCY_ADDITIONAL_SHIPPING_LABEL',
  /** 배송대행 관리 - 추가 운송장 출력 */
  DELIVERY_AGENCY_ADDITIONAL_SHIPPING_LABEL_PRINT: 'DELIVERY_AGENCY_ADDITIONAL_SHIPPING_LABEL_PRINT',
  /** 회수 관리·회수 결과 리포트 - 검색 결과 0건 (검색 전은 공통 INIT 재사용) */
  COLLECTING_REQUEST_EMPTY: 'COLLECTING_REQUEST_EMPTY',
  /** 반품 신청 1step - 검색 결과 0건 (검색 전은 공통 INIT 재사용) */
  COLLECTING_CANDIDATE_EMPTY: 'COLLECTING_CANDIDATE_EMPTY',
} as const;

export type TypeNoRowsStatusKey = keyof typeof NoRowsStatusType;

export const NO_ROWS_MESSAGE: { [key in TypeNoRowsStatusKey]: string } = {
  INIT: '원하는 조건 입력 후 검색 버튼을 눌러주세요.',
  EMPTY: '검색 결과에 해당하는 데이터가 없습니다.',
  SEARCH_EMPTY: '등록된 데이터가 없습니다.',
  RECEIVE_REGISTER: '입고 센터, 공급사를 선택 후\n상품을 추가할 수 있습니다.',
  NO_DATA: '데이터가 없습니다.',
  DELIVERY_AGENCY_ADDITIONAL_SHIPPING_LABEL: '출고 번호 또는 운송장 번호로\n추가 운송장 생성할 주문을 검색해 주세요.',
  DELIVERY_AGENCY_ADDITIONAL_SHIPPING_LABEL_PRINT: '운송장 번호 추가 생성 후\n추가 생성한 운송장을 출력할 수 있습니다.',
  STOCK_RELEASE_REGISTER: '반출 출발지 센터를 선택하여 검색 후\n상품을 추가할 수 있습니다.',
  COLLECTING_REQUEST_EMPTY: '검색 결과가 없습니다.',
  COLLECTING_CANDIDATE_EMPTY: '검색 조건과 일치하는 주문이 없습니다.',
};
